exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-body[data-v-d63d245c]{\n  max-height: 500px !important;\n  overflow: auto !important;\n}\n\n/* Style for bracketed alphabetic list items */\nol.bracketed-list[data-v-d63d245c] {\n  counter-reset: item;\n  padding-left: 30px;\n}\nol.bracketed-list li[data-v-d63d245c] {\n  list-style: none;\n  margin-bottom: 40px;\n}\nol.bracketed-list li[data-v-d63d245c]:before {\n  content: \"(\" counter(item, lower-alpha) \")\";\n  counter-increment: item;\n  display: inline-block;\n  margin-right: 20px;\n}\nol.bracketed-list li input[data-v-d63d245c] {\n  width: 90%;\n  float: right;\n}\n", ""]);

// exports
